import './App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import FeedbackForm from './components/FeedbackForm';
import { HomePage } from './HomePage';
import { ComingSoon } from './components/ComingSoon';

export function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/feedback" element={< ComingSoon/>} />
      </Routes>
    </BrowserRouter>
  );}